<template>
    <div class="wp">
        <div class="home-1"></div>
        <!-- <div class="home-2">
            <div class="home-2-c">
                <div class="home-2-c-item" style="padding-right:10px;">
                    <el-carousel indicator-position="none" height="400px">
                        <el-carousel-item v-for="(item,index) in imgs" :key="index">
                            <img :src="require('../../assets/image/home/'+item.path)">
                            <p class="img-title">{{item.title}}</p>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="home-2-c-item" style="padding-left:10px;">
                    <p class="h2ci-title pointer" @click="getDetail(topInfo.id,'今日头条')">
                        {{topInfo.infoTitle}}
                    </p>
                    <p class="h2ci-d pointer" @click="getDetail(topInfo.id,'今日头条')">
                        {{topInfo.infoTitle}}
                        8日下午，习近平总书记来到宁夏吴忠市利通区金花园社区考察。志愿者代表、70岁的回族老党员王兰花告诉总书记，他们2005年成立志愿者服务队，从最初的7名成员发展到现在6万多名，越来越多人参与到志愿服务中...
                    </p>
                    <div class="i-box"> 
                        <div v-for="(item,index) in topInfo6" :key="index" class="item pointer" @click="getDetail(item.id,'今日头条')">
                            <p class="i-title">{{item.infoTitle}}</p>
                            <p class="i-time">{{item.modifyDate}}</p>
                        </div>
                    <div class="item">
                        <p class="i-title">联防联控机制联络组调研指导疫苗研发生产</p>
                        <p class="i-time">2020-12-11</p>
                    </div>
                    <div class="item">
                        <p class="i-title">外交部:奉劝澳方个别人正视问题、反躬自省</p>
                        <p class="i-time">2020-12-11</p>
                    </div>
                    <div class="item">
                        <p class="i-title">教育部等发文规范校外培训机构服务行为</p>
                        <p class="i-time">2020-12-11</p>
                    </div>
                    <div class="item">
                        <p class="i-title">财政部等下拨2亿元中央防汛抗旱补助资金</p>
                        <p class="i-time">2020-12-11</p>
                    </div>
                    <div class="item">
                        <p class="i-title">加大“学习强国”学习平台版权保护力度 剑网2020</p>
                        <p class="i-time">2020-12-11</p>
                    </div>
                    </div>
                    
                </div>
            </div>
        </div> -->
        <div class="w-1200 home-3">
            <div class="h-3-item pull-left">
                <com-news newsTitle='重要通知' :top="topImportantNotice" :top6="importantNotice6" @getList='getList' @getDetail='getDetail'></com-news>
            </div>
            <div class="h-3-item pull-right">
                 <com-news newsTitle='最新资讯' :top="topNewsInfo" :top6="newsInfo6" @getList='getList' @getDetail='getDetail'></com-news>
            </div>
        </div>
        <div class="w-1200 home-4">
            <div class="title-more">
                    <div class="t-m-blue"></div>
                    <p class="t-m-t">示范产品</p>
                    <p class="t-m-m pointer" @click="getDemoList('示范产品')">MORE +</p>
            </div>
            <com-product v-if="productState" :num=8  :list="demoProduct" title="示范产品" @getDetail="getDetail"></com-product>
        </div>
        <div class="w-1200 home-5">
             <div class="h-3-i-up">
                <p class="h-3-i-t">示范应用</p>
                <p class="h-3-i-m pointer" @click="getDemoList('示范应用')">MORE +</p>
                <div class="triangle"></div>
            </div>
            <div class="h-5-d">
                <el-row style="margin-top:20px;" :gutter="10">
                    <el-col class="m-b-10"  v-for="(item,index) in demoStration" :key="index" :span="6" >
                        <div  class="img-item pointer" @click="getDetail(item.id,'示范应用')">
                            <el-image style="width: 100%; height: 100%" :src="item.fgpic" fit="contain">
                                <!-- <div slot="error"   class="image-slot" style="width:100%;height:100%;">
                                                <img style="object-fit: fill;width:100%;height:100%;"  src="../../assets/image/home/home-img3.png">
                                                </div> -->
                            </el-image>
                        </div>
                    </el-col>
                </el-row>
            </div>
            
        </div>
    </div>
</template>
<script>
import Home from './Home.js';
export default Home;
</script>
<style lang="scss" scoped>
@import './home.scss';
</style>